/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetFileTemplateResponse } from '../models/get-file-template-response';
import { CreateFileTemplateRequest } from '../models/create-file-template-request';
import { UpdateFileTemplateRequest } from '../models/update-file-template-request';
@Injectable({
  providedIn: 'root',
})
class FileTemplateService extends __BaseService {
  static readonly FileTemplateGetTemplateByTypePath = '/FileTemplate/GetTemplateByType';
  static readonly FileTemplateGetAllPath = '/FileTemplate/GetAll';
  static readonly FileTemplateGetByIdPath = '/FileTemplate/GetById';
  static readonly FileTemplateCreatePath = '/FileTemplate/Create';
  static readonly FileTemplateCreateRangePath = '/FileTemplate/CreateRange';
  static readonly FileTemplateUpdatePath = '/FileTemplate/Update';
  static readonly FileTemplateDeletePath = '/FileTemplate/Delete';
  static readonly FileTemplateDeleteRangePath = '/FileTemplate/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param type undefined
   */
  FileTemplateGetTemplateByTypeResponse(type?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7): __Observable<__StrictHttpResponse<Array<GetFileTemplateResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (type != null) __params = __params.set('type', type.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/FileTemplate/GetTemplateByType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetFileTemplateResponse>>;
      })
    );
  }
  /**
   * @param type undefined
   */
  FileTemplateGetTemplateByType(type?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7): __Observable<Array<GetFileTemplateResponse>> {
    return this.FileTemplateGetTemplateByTypeResponse(type).pipe(
      __map(_r => _r.body as Array<GetFileTemplateResponse>)
    );
  }
  FileTemplateGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetFileTemplateResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/FileTemplate/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetFileTemplateResponse>>;
      })
    );
  }  FileTemplateGetAll(): __Observable<Array<GetFileTemplateResponse>> {
    return this.FileTemplateGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetFileTemplateResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  FileTemplateGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetFileTemplateResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/FileTemplate/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetFileTemplateResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  FileTemplateGetById(Id?: string): __Observable<GetFileTemplateResponse> {
    return this.FileTemplateGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetFileTemplateResponse)
    );
  }

  /**
   * @param request undefined
   */
  FileTemplateCreateResponse(request: CreateFileTemplateRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/FileTemplate/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  FileTemplateCreate(request: CreateFileTemplateRequest): __Observable<Blob> {
    return this.FileTemplateCreateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  FileTemplateCreateRangeResponse(request: Array<CreateFileTemplateRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/FileTemplate/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  FileTemplateCreateRange(request: Array<CreateFileTemplateRequest>): __Observable<Blob> {
    return this.FileTemplateCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  FileTemplateUpdateResponse(request: UpdateFileTemplateRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/FileTemplate/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  FileTemplateUpdate(request: UpdateFileTemplateRequest): __Observable<Blob> {
    return this.FileTemplateUpdateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  FileTemplateDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/FileTemplate/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  FileTemplateDelete(id?: string): __Observable<Blob> {
    return this.FileTemplateDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  FileTemplateDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/FileTemplate/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  FileTemplateDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.FileTemplateDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module FileTemplateService {
}

export { FileTemplateService }
